module.exports = __webpack_public_path__ + "assets/img/23c36aac8a9e426b52ec79683a3084ce.png";